import { jsx } from "react/jsx-runtime";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { forwardRef } from "react";
import { useConstant } from "../../../hooks/index.js";
import { EditorContext } from "../context/index.js";
import { useEditorTheme } from "../theme/index.js";
import { Editor } from "./Editor.js";
import { nodes } from "./nodes.js";
function defaultHandleError(error) {
  console.error(error);
  console.warn("initialConfig.onError is missing. Please provide it to handle the errors raised by the Editor.");
}
const EditorProvider = forwardRef(function EditorProvider2(props, ref) {
  const { disabled, namespace = "tidal-editor", initialConfig, editorThemeStyles, initialToolbarVisible } = props;
  const editorTheme = useEditorTheme(editorThemeStyles);
  const hydratedInitialConfig = useConstant(() => ({
    theme: editorTheme,
    namespace,
    onError: defaultHandleError,
    ...initialConfig,
    nodes: [...nodes, ...initialConfig?.nodes ?? []]
  }));
  return /* @__PURE__ */ jsx(LexicalComposer, { initialConfig: hydratedInitialConfig, children: /* @__PURE__ */ jsx(EditorContext, { disabled, initialToolbarVisible, children: /* @__PURE__ */ jsx(Editor, { ref, ...props }) }) });
});
export {
  EditorProvider
};
//# sourceMappingURL=EditorProvider.js.map
